import React, { useContext, useMemo, useState } from "react";
import style from "./index.module.scss";
import { Breadcrumb, Button, Dropdown, Icon, Menu } from "antd";
import NavBar from "./components/NavBar";
import CourseHeader from "./components/CourseHeader";
import { Link, useHistory } from "react-router-dom";
import useDeviceType from "Utils/useDeviceType";
import { CourseContext } from "../../Store";
import useRequest from "Utils/useRequest";
import { getContactList } from "API/chat";
import useModalHandler from "Utils/useModalHandler";
import ChatModal from "components/WebIM/Components/ChatModal";
import { SubLayout } from "../../../../components/Layouts/SubLayout";
import { SubLayoutHeader } from "../../../../components/Layouts/SubLayout/Component/SubLayoutHeader";

interface CourseLayoutProps {
    children: React.ReactNode;
}

export default function CourseLayout({ children }: CourseLayoutProps) {
    const history = useHistory();
    const { isPC } = useDeviceType();
    const chatModal = useModalHandler();

    const { course } = useContext(CourseContext);
    const { courseNo, courseSeq, weekTimeId } = course;

    const [allContactList] = useRequest(() => getContactList());
    const [selectedContact, setSelectedContact] = useState({
        no: "",
        name: ""
    });

    const onOpenChat = (select: string) => {
        const [no, name] = select.split("-");
        setSelectedContact({ no, name });
        chatModal.open();
    };

    const contactList = allContactList?.find(
        item => item.key === courseNo + courseSeq
    )?.children;

    const menu = (
        <Menu>
            {contactList?.map(item => (
                <Menu.Item key={item.key} onClick={() => onOpenChat(item.key)}>
                    {item.title}
                    {item.isMain === "1" && contactList.length > 1 && (
                        <span className={style.majorflag}>主讲</span>
                    )}
                </Menu.Item>
            ))}
        </Menu>
    );

    const chapterBtn = useMemo(
        () => (
            <div>
                {contactList?.length === 1 && (
                    <Button
                        type="link"
                        className={style.chatBtn}
                        onClick={() => onOpenChat(contactList[0].key)}>
                        <Icon type="message" />
                    </Button>
                )}
                {contactList && contactList.length > 1 && (
                    <Dropdown overlay={menu} trigger={["click"]}>
                        <Button type="link" className={style.chatBtn}>
                            <Icon type="message" />
                        </Button>
                    </Dropdown>
                )}
                <Link
                    className={style.chapterBtn}
                    title="课程章节"
                    to={`/course/chapters/${courseNo}/${courseSeq}/${weekTimeId}`}>
                    <Icon type="calendar" />
                </Link>
            </div>
        ),
        [courseNo, courseSeq, weekTimeId, contactList]
    );

    return (
        <SubLayout>
            <SubLayoutHeader title="课程内容" extra={chapterBtn} />

            <div className={style.container}>
                {isPC && (
                    <Breadcrumb separator=">">
                        <Breadcrumb.Item href="/">首页</Breadcrumb.Item>
                        <Breadcrumb.Item>课程内容</Breadcrumb.Item>
                    </Breadcrumb>
                )}

                <div className={style.body}>
                    <CourseHeader contactList={contactList || []} />

                    <NavBar />

                    <div className={style.main}>{children}</div>
                </div>
            </div>

            {!isPC && (
                <ChatModal
                    visible={chatModal.visible}
                    courseNo={course.courseNo}
                    courseSeq={courseSeq}
                    onCancel={chatModal.close}
                    selectedContact={selectedContact}
                />
            )}
        </SubLayout>
    );
}
